import clsx from 'clsx';
import { PlusIcon } from '@music-vine/cadence/icons';
import { Button } from '@music-vine/cadence/ui';
import Tooltip from '@/components/Tooltip';
interface ChannelSafelistInnerProps {
  children: React.ReactNode;
  disabled?: boolean;
  handleEdit?: () => void;
  hasChannel?: boolean;
  isEditing?: boolean;
  isFetching?: boolean;
  isLoading?: boolean;
  showTooltip?: boolean;
  tooltipLabel?: string;
}
export const ChannelSafelistInner = ({
  children,
  isLoading,
  hasChannel,
  isEditing,
  isFetching,
  handleEdit,
  disabled,
  tooltipLabel,
  showTooltip
}: ChannelSafelistInnerProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      if (disabled) {
        return;
      }
      handleEdit?.();
    }
  };
  if (isLoading) {
    return <div className="circle-loader">
        <div className="bounce1" />
        <div className="bounce2" />
        <div className="bounce3" />
      </div>;
  }
  if (hasChannel || isEditing) {
    return <div className={clsx('container-inline z-[1] flex h-full w-full flex-col items-center justify-center rounded-xl font-sans text-[#232525] transition-opacity duration-200 ease-in-out', isFetching && 'opacity-80')}>
        {children}
      </div>;
  }
  return <div className={clsx('flex h-full w-full cursor-pointer items-center justify-center', 'rounded-xl focus:outline-1 focus:outline-pink-500', 'text-pink-500', disabled && 'cursor-not-allowed')} onClick={disabled ? undefined : handleEdit} onKeyDown={handleKeyDown} role="button" tabIndex={0} data-sentry-component="ChannelSafelistInner" data-sentry-source-file="ChannelWhitelistInner.tsx">
      <Tooltip forceShow={showTooltip} label={tooltipLabel} side="bottom" data-sentry-element="Tooltip" data-sentry-source-file="ChannelWhitelistInner.tsx">
        <div>
          <Button aria-label="Add channel" asChild borderRadius="full" className="transition-none hover:bg-pink-500 hover:fill-uppbeat group-hover:bg-transparent" disabled={disabled} size="icon" variant="brand" data-sentry-element="Button" data-sentry-source-file="ChannelWhitelistInner.tsx">
            <div>
              <PlusIcon className="size-5 stroke-[2.5px]" data-sentry-element="PlusIcon" data-sentry-source-file="ChannelWhitelistInner.tsx" />
            </div>
          </Button>
        </div>
      </Tooltip>
    </div>;
};